module.exports = __webpack_public_path__ + "img/logo.09c08d75.png";